import { render, staticRenderFns } from "./safOpinionBoardDetail.vue?vue&type=template&id=6c2e61c8"
import script from "./safOpinionBoardDetail.vue?vue&type=script&lang=js"
export * from "./safOpinionBoardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2e61c8')) {
      api.createRecord('6c2e61c8', component.options)
    } else {
      api.reload('6c2e61c8', component.options)
    }
    module.hot.accept("./safOpinionBoardDetail.vue?vue&type=template&id=6c2e61c8", function () {
      api.rerender('6c2e61c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sob/safOpinionBoardDetail.vue"
export default component.exports